module.exports = __webpack_public_path__ + "static/media/kordrengirunknown.e343ba66.svg";